import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';
import './ProfileMenu.scss';
import { useOnClickOutside } from 'utils/helpers';
import { PROFILE_MENU_STATUS, QOUTE_MENU_STATUS, ROUTES, USER_ROLES } from 'config/constants';
import logout from 'assets/images/header/logout.svg';
import gearIcon from 'assets/images/header/gear.svg';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { handleLogout } from 'redux/reducers/auth';
import lockIcon from 'assets/images/general/lock.svg';
import reccommendIcon from 'assets/images/general/recommend-icon.svg';
import inviteIcon from 'assets/images/general/invite-icon.svg';
import ActivityIndicator from 'creatella-react-components/lib/ActivityIndicator';

ProfileMenu.propTypes = {
    doLogout: PropTypes.func.isRequired,
    profileMenuStatus: PropTypes.number.isRequired,
    setProfileMenuStatus: PropTypes.func.isRequired,
    profileLinkRef: PropTypes.oneOfType([
        // Either a function
        PropTypes.func,
        // Or the instance of a DOM native element (see the note about SSR)
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ]),
    onLockClick: PropTypes.func.isRequired,
    updateBackdrop: PropTypes.func.isRequired,
    role: PropTypes.number,
    showInviteUser: PropTypes.func
};

function ProfileMenu({
    doLogout,
    profileMenuStatus,
    setProfileMenuStatus,
    profileLinkRef,
    onLockClick,
    updateBackdrop,
    role,
    showInviteUser
}) {
    const isVisible = profileMenuStatus !== PROFILE_MENU_STATUS.HIDDEN;
    const profileMenuRef = useRef();
    const history = useHistory();
    const [loadingLogout, setLoadingLogout] = useState(false);

    useOnClickOutside(profileMenuRef, useCallback(() => {
        setProfileMenuStatus(PROFILE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
    }, [setProfileMenuStatus, updateBackdrop]), profileLinkRef);

    const onLogoutClick = () => {
        setLoadingLogout(true);
        doLogout();
    };

    const onSettingsClick = () => {
        history.replace(role !== USER_ROLES.DATA_USER ? ROUTES.SETTINGS_NOTIFICATIONS : ROUTES.SETTINGS_DATAUSER_PROFILE);
        setProfileMenuStatus(PROFILE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
    };

    const onLockButtonClick = () => {
        onLockClick();
        setProfileMenuStatus(PROFILE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
    };

    const onRecommendProduct = () => {
        history.replace(ROUTES.RECOMMEND_MARKET);
        updateBackdrop(false);
    };

    const onShowInviteUser = () => {
        setProfileMenuStatus(PROFILE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
        showInviteUser();
    };

    return (
        !isVisible ? false
            : <div className={'profile-menu'}>
                <div ref={profileMenuRef} className={'profile-menu__container'}>
                    <div className='profile-menu__pointer' />
                    <div className={'profile-menu__wrapper'}>
                        <div className={'profile-menu__body'} >
                            <div className={'profile-menu__row'} onClick={onSettingsClick}><img alt='settings' src={gearIcon}/> Settings</div>
                            <div className={'profile-menu__row'} onClick={onLockButtonClick}><img alt='settings' src={lockIcon}/> Lock Screen</div>
                            {role !== USER_ROLES.ADMIN &&
                            <div className={'profile-menu__row'} onClick={onRecommendProduct}><img alt='settings' style={{ width: '21px', height: '42px' }} src={reccommendIcon}/> Recommend Market</div>}
                            <div className={'profile-menu__row'} onClick={onShowInviteUser}><img alt='settings' style={{ width: '21px', height: '20px' }} src={inviteIcon}/> Invite User</div>
                            <div className={'profile-menu__row'} onClick={onLogoutClick}><img alt='logout' src={logout}/> {loadingLogout ? <ActivityIndicator size={15}/> : 'Logout'}</div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

function mapDispatchToProps(dispatch) {
    return {
        doLogout: () => {
            dispatch(handleLogout());
        }
    };
}

export default connect(null, mapDispatchToProps)(ProfileMenu);

QoutesMenu.propTypes = {
    qouteMenuStatus: PropTypes.number.isRequired,
    setQouteMenuStatus: PropTypes.func.isRequired,
    qouteLinkRef: PropTypes.oneOfType([
        // Either a function
        PropTypes.func,
        // Or the instance of a DOM native element (see the note about SSR)
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ]),
    updateBackdrop: PropTypes.func.isRequired
};

function QoutesMenu({
    qouteMenuStatus,
    setQouteMenuStatus,
    qouteLinkRef,
    updateBackdrop
}) {
    const isVisible = qouteMenuStatus !== QOUTE_MENU_STATUS.HIDDEN;
    const profileMenuRef = useRef();
    const history = useHistory();

    useOnClickOutside(profileMenuRef, useCallback(() => {
        setQouteMenuStatus(QOUTE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
    }, [setQouteMenuStatus, updateBackdrop]), qouteLinkRef);

    const openQoute = () => {
        setQouteMenuStatus(PROFILE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
        history.replace(ROUTES.HOME);
    };

    const openFreight = () => {
        setQouteMenuStatus(PROFILE_MENU_STATUS.HIDDEN);
        updateBackdrop(false);
        history.replace(ROUTES.FRIEGHT);
    };

    return (
        !isVisible ? false
            : <div className={'profile-menu'}>
                <div ref={profileMenuRef} className={'profile-menu__container'}>
                    <div className='profile-menu__pointer' />
                    <div className={'profile-menu__wrapper'}>
                        <div className={'profile-menu__body'} >
                            <div className={'profile-menu__row'} onClick={openQoute}><img alt='settings' style={{ opacity: '0%' }} src={gearIcon}/> Quotes</div>
                            <div className={'profile-menu__row'} onClick={openFreight}><img alt='settings' style={{ opacity: '0%' }} src={lockIcon}/> Freight</div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export { QoutesMenu };
